import openbetImg from '../../Assets/openbet.png';
import stonebranchImg from '../../Assets/stonebranch.png';
const experienceData = [
    {
      id: 1,
      company: "OpenBet-SG Digital",
      location: "Greece",
      role: "Software Engineer",
      period: "02/2022 – 08/2023",
      details: [
        "Full Stack Developer for Promotions Team",
        "Technologies Used: Java - Spring Boot, TCL, JavaScript - React, Angular, Docker, PostgreSQL",
        "Designing, implementing, extending, and deploying solutions",
        "Implementing solutions for the [OPAP project](https://www.pamestoixima.gr/?lang=el)",
        "In Jan 2023, promoted to Software Engineer L2 from L1"
      ],
      url: "https://www.openbet.com/",
    imageUrl: openbetImg,
    },
    {
      id: 2,
      company: "Stonebranch",
      location: "Greece",
      role: "Software Engineer",
      period: "09/2021 - 01/2022",
      details: [
        "Universal Automation Center",
        "Solutions Extensions Development Team – [Integration hub](https://www.stonebranch.com/integration-hub/)",
        "Python, Docker, Jenkins, Vagrant",
        "Designing, implementing, extending, testing, and documenting solutions"
      ],
      url: "https://www.stonebranch.com/",
    imageUrl: stonebranchImg,
    },
    {
      id: 3,
      company: "Stonebranch",
      location: "Greece",
      role: "Software Engineer Intern",
      period: "07/2021 - 09/2021",
      details: [
        "Solutions Extensions Development Team",
        "Designing solutions, Troubleshooting, and bug fixing"
      ],
      url: "https://www.stonebranch.com/",
    imageUrl: stonebranchImg,
    },
  ];

  export default experienceData;